export const LOCAL_STORAGE_KEY = 'first-point';
export const SESSION_STORAGE_KEY = 'session-point';

export const phone = '+1 800 967 7762';
export const email = 'vn@andersenlab.com';
